import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import QuickPlacementTestForm from '../../features/quick-placement-tests-form/ui/QuickPlacementTestForm';
import { getAdminPlacementTestTemplateById } from '../../shared/api/placement-tests.services';
import AdminPageLoader from '../../shared/ui/admin-loader/AdminPageLoader';
import { getLocalizedValue } from '../../shared/lib/localization';
import { useState, useEffect } from 'react';

const QuickPlacementTestsRewritePage = () => {
  const { templateId } = useParams();
  const navigate = useNavigate();
  const [template, setTemplate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (templateId) {
      fetchTemplate();
    }
  }, [templateId]);

  const fetchTemplate = async () => {
    setIsLoading(true);
    try {
      const data = await getAdminPlacementTestTemplateById(templateId);
      setTemplate(data);
    } catch (err) {
      console.error('Error fetching template:', err);
      setError(err.message || 'Помилка при завантаженні');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="page-wrapper">
        <div className="loading">Завантаження...</div>
      </div>
    );
  }

  if (error && !template) {
    return (
      <div className="page-wrapper">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (!template) {
    return (
      <div className="page-wrapper">
        <div className="error-message">Шаблон не знайдено</div>
      </div>
    );
  }

  return (
    <>
      <section className="section-admin section-form">
        <div className="section-form__header">
          <h2>Редагування міні-тесту: {getLocalizedValue(template.title, 'ua')}</h2>
          <button onClick={() => navigate('/quick-placement-tests')}>Повернутися</button>
        </div>

        {!isLoading && !error && (
          <QuickPlacementTestForm initialData={template} templateId={templateId} />
        )}
      </section>

      <button form="quick-placement-test-form" className="product-form__submit" type="submit" disabled={isLoading}>
        Зберегти
      </button>
    </>
  );
};

export default QuickPlacementTestsRewritePage;
